import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { TextField, Toolbar } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import axios from "axios";
import Checkbox from '@mui/material/Checkbox';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

// Custom styling for the modal
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "30px",
  width: {
    xs: "90%",
    sm: "80%",
    md: "70%",
    lg: "60%",
    xl: "50%",
  },
  maxHeight: "90vh",
  overflowY: "auto",
};

// Hidden input for file upload
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function AddProductModal({ setProduct }) {
  const [open, setOpen] = React.useState(false);
  const [snackbarState, setSnackbarState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });

  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState(0);
  const [productImages, setProductImages] = useState([]);
  const [productImagesFile, setProductImagesFile] = useState([]);
  const [flower, setFlower] = useState([]);
  const [selectedflower, setSelectedFlower] = useState([]);
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [delived, setDelived] = useState(false);

  const theme = useTheme();

  const createProduct = (e) => {
    e.preventDefault();

    // Log the data to verify fields before sending
    const productData = {
      productName,
      price,
      catName: selectedCategory,
      productImages,
      flowers: selectedflower,
      delived: delived,
    };

    const headers = {
      "Content-Type": "multipart/form-data",
    };

    const formData = new FormData();
    formData.append("productName", productName);
    formData.append("price", price);
    formData.append("delived", delived);
    // category: String,
    // formData.append("catName", selectedCategory);
    formData.append("category", selectedCategory);
    selectedflower.forEach((flower) => formData.append("flowers", flower));
    productImagesFile.forEach((image, index) => {
      formData.append(`images[${index}]`, image);
    });

    console.log("Creating product with data:", productData);

    // Axios POST request
    axios
      .post("https://tsetsegtuw.templateapi.xyz/product", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((el) => {
        setSnackbarState({
          ...snackbarState,
          open: true,
          message: "Амжилттай хадгалагдлаа",
        });
        window.location.reload(false);
      })
      .catch((error) => {
        console.error(
          "Error adding product:",
          error.response ? error.response.data : error.message
        );
        setSnackbarState({
          ...snackbarState,
          open: true,
          message: "Failed to add product",
        });
      });
  };

  useEffect(() => {
    axios
      .get("https://tsetsegtuw.templateapi.xyz/flower")
      .then((res) => setFlower(res.data.data))
      .catch((er) => console.log(er));
    axios
      .get("https://tsetsegtuw.templateapi.xyz/categories")
      .then((res) => setCategory(res.data.data))
      .catch((er) => console.log(er));
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSnackbarClose = () => {
    setSnackbarState({ ...snackbarState, open: false });
  };

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    setProductImagesFile(Array.from(selectedFiles)); // Convert FileList to array
    const fileArray = Array.from(selectedFiles).map((file) =>
      URL.createObjectURL(file)
    );
    setProductImages((prevImages) => prevImages.concat(fileArray));
  };

  const removeImage = (url) => {
    setProductImages(productImages.filter((img) => img !== url));
  };

  return (
    <Toolbar>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Баглаа нэмэх
      </Button>
      <Modal
        sx={{ overflow: "scroll" }}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <DialogTitle
            sx={{
              color: theme.palette.mode === "dark" ? "white" : "black",
            }}
          >
            Баглаа нэмэх
            <IconButton onClick={handleClose} style={{ float: "right" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Stack spacing={4} margin={2}>
              <TextField
                variant="outlined"
                label="Гарчиг"
                sx={{ width: "50%" }}
                value={productName}
                onChange={(e) => setProductName(e.target.value)}
              />
              <TextField
                variant="outlined"
                label="Үнэ"
                sx={{ width: "50%" }}
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />

              <FormControl>
                <InputLabel id="category-select-label">Ангилал</InputLabel>
                <Select
                  sx={{ width: "50%" }}
                  labelId="category-select-label"
                  id="category-select"
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  {category.map((item) => (
                    <MenuItem key={item._id} value={item._id}>
                      {item.catName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl>
                <InputLabel id="flower-select-label">Орц</InputLabel>
                <Select
                  sx={{ width: "50%" }}
                  labelId="flower-select-label"
                  id="flower-select"
                  value={selectedflower}
                  multiple
                  onChange={(e) => setSelectedFlower(e.target.value)}
                  renderValue={(selected) => selected.join(", ")}
                >
                  {flower.map((item) => (
                    // Ensure 'item' exists and 'flowerName' is defined
                    <MenuItem key={item?._id} value={item?.flowerName || ""}>
                      {item?.flowerName || "Unknown"}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <div className="flex justify-start items-center">
                <Checkbox onClick={() => setDelived(!delived)} value={delived} {...label} />
                <p>{delived ? 'Хүргэлттэй' : 'Хүргэлтгүй'}</p>
              </div>
              <Button
                component="label"
                variant="contained"
                startIcon={<CloudUploadIcon />}
                sx={{ minWidth: "25%", maxWidth: "40%" }}
              >
                Upload photos
                <VisuallyHiddenInput
                  type="file"
                  onChange={handleFileChange}
                  // accept="image/png, image/jpeg"
                  multiple
                />
              </Button>

              <Box id="image-preview" display="flex" flexWrap="wrap">
                {productImages.map((imageSrc, index) => (
                  <Box key={index} sx={{ position: "relative", margin: 1 }}>
                    <img
                      src={imageSrc}
                      alt={`preview-${index}`}
                      style={{ width: 100, height: 100, objectFit: "cover" }}
                    />
                    <IconButton
                      sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        backgroundColor: "white",
                      }}
                      onClick={() => removeImage(imageSrc)}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                ))}
              </Box>

              <Box display="flex" justifyContent="space-between">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={createProduct}
                >
                  Хадгалах
                </Button>
                <Button variant="contained" color="error" onClick={handleClose}>
                  Хаах
                </Button>
              </Box>
            </Stack>
          </DialogContent>
        </Box>
      </Modal>

      <Snackbar
        anchorOrigin={{
          vertical: snackbarState.vertical,
          horizontal: snackbarState.horizontal,
        }}
        open={snackbarState.open}
        onClose={handleSnackbarClose}
        message="Амжилттай хадгалагдлаа"
        key={snackbarState.vertical + snackbarState.horizontal}
      />
    </Toolbar>
  );
}
